import { Component, Inject, OnInit } from '@angular/core';
import { LoaderService } from './loader/LoaderService';
import { LoaderState } from './loader/loaderState';
import { Subscription } from 'rxjs';
import { Broadcaster } from './app.broadcaster';
import { CommonService } from './services/common.service';
import $ from '../assets/js/jquery-3.3.1.min';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, RouterEvent } from '@angular/router';
import * as firebase from 'firebase/app';
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics';
// import 'firebase/messaging';
// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';
import { environment } from '../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
// import entire SDK


// import AWS object without services


import {
    NavigationEnd
} from '@angular/router';

import { EventPrefixValue } from './app.config';

declare var fbq: any;
declare var GM: any;
declare var ga: any;
declare var AF: any;
declare var smartech: any;
declare var Fingerprint2: any;
declare var clevertap: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [Broadcaster, CommonService]
})

export class AppComponent implements OnInit {
    title = 'myteam11';
    show: boolean;
    showPreview: boolean = false;
    popShow: boolean;
    language: boolean;
    message: any;
    sidePanel: boolean;
    eventPrefixValue
        = EventPrefixValue;
    isSelenium: boolean;
    currentState: string;
    isHt: boolean;

    constructor(public commonService: CommonService, private httpClient: HttpClient, private loaderService: LoaderService,
        private broadcaster: Broadcaster, private router: Router, private deviceService: DeviceDetectorService) {
        this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                setTimeout(() => {
                    if (!state.show) {
                        this.show = state.show;
                    } else {
                        this.show = state.show;
                    }
                });
            });
        if (environment.isHT) {
            this.router.events.subscribe((event: RouterEvent) => {
                this.navigationInterceptor(event);
            });
        }
        if (!localStorage.getItem('deviceId')) {
            new Fingerprint2().get((result, components) => {
                console.log(result);
                localStorage.setItem('deviceId', result);
            });
        }
        this.broadcaster.on<boolean>('setBgOrNot').subscribe((response) => {
            this.popShow = response;
        });
        this.broadcaster.on<boolean>('showPreview').subscribe((response) => {
            this.showPreview = response;
        });
        this.broadcaster.on<boolean>('sidePanel').subscribe((response) => {
            this.sidePanel = response;
        });

        if (window.location.href.indexOf('https://www.myteam11.com/fantasy-cricket') !== -1) {
            window.location.href = 'https://www.myteam11.com/fantasy-sports';
        }
        this.broadcaster.on<boolean>('language').subscribe((response) => {
            this.changeStyleAccordingLanguage();
        });
        this.changeStyleAccordingLanguage();
        this.commonService.languageAPICall();
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationEnd) {
            ga('set', 'page', event.urlAfterRedirects);
            ga('send', 'pageview');
        }
    }

    ngOnInit() {
        localStorage.removeItem('compTeamInfo');
        localStorage.removeItem('switch');
        this.isHt = environment.isHT;
        this.currentState = 'initial';
        if (environment.production) {
            this.isSelenium = navigator.webdriver;
        }
        const matchInfo = JSON.parse(localStorage.getItem('match_info'));
        const data = JSON.stringify({ matchMode: 2, matchType: matchInfo ? matchInfo.matchType : 1 });
        localStorage.setItem('match_info', data);
        if (matchInfo) {
            matchInfo.matchMode = 2;
        }
        if (environment.production) {
            fbq('init', '169460291144051');
            fbq('track', 'PageView');
        }

        const urlParams = new URLSearchParams(window.location.search);
        const campaignId = urlParams.get('campaignId');
        localStorage.setItem('branchCampaignId', campaignId);
        smartech('create', environment.smartech.create);
        // clevertap.init(environment.clevertap.apiKey, 'in1');
        clevertap.privacy.push({ useIP: true });
        clevertap.spa = true
        smartech('register', environment.smartech.register);

        if (localStorage.getItem('save_token')) {
            const userData = JSON.parse(localStorage.getItem('save_token'));
            smartech('identify', userData.UserId);
        } else {
            smartech('identify', environment.smartech.identify);
        }
        smartech('dispatch', 1, {});
        this.commonService.deviceInfo = this.deviceService.getDeviceInfo();
        if (this.commonService.deviceInfo.browser === 'Safari' && this.commonService.deviceInfo.os === 'iOS') {
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('safari');
        }
        firebase.initializeApp(environment.firebase);
        this.commonService.analytics = firebase.analytics();
        this.commonService.fireStore = firebase.firestore();
        const userInfo = this.commonService.getTokenInfo(true);
        if (userInfo[0].value) {
            this.commonService.analytics.setUserId(userInfo[0].value);
        }
        localStorage.removeItem('allCategoryPosition');
    }


    changeState() {
        this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
    }

    notificationRequest(token) {
        const userInfo = this.commonService.getTokenInfo(true);
        if (userInfo[0].value) {
            this.httpClient.request(
                'get',
                environment.apiUrl + 'version/getversion',
                {
                    headers: new HttpHeaders().set('version', 'web')
                }
            ).subscribe((response: any) => {
                let initial_value: any;
                if (localStorage.getItem('push_notification_count')) {
                    const previous_count: number = +localStorage.getItem('push_notification_count');
                    const current_count: number = +response.Response.NotificationCount;
                    if (current_count > previous_count) {
                        localStorage.setItem('push_notification_count', response.Response.NotificationCount);
                        initial_value = true;
                    }
                } else {
                    initial_value = true;
                    localStorage.setItem('push_notification_count', response.Response.NotificationCount);
                }
                if (initial_value) {
                    const headerValue = new HttpHeaders()
                        .set('UserId', userInfo[0].value)
                        .set('ExpireToken', userInfo[1].value)
                        .set('AuthExpire', userInfo[2].value)
                        .set('Initial', initial_value)
                        .set('Type', 'web')
                        .set('Token', token);
                    // this.httpClient.request(
                    //     'get',
                    //     environment.apiUrl + 'myprofile/get-subscription-items',
                    //     {
                    //         headers: headerValue
                    //     }
                    // ).subscribe(() => {
                    // });
                }
            });
        }
    }

    showBgColor() {
        return this.router.url.indexOf('landing') !== -1 || this.router.url.indexOf('login') !== -1
            || this.router.url.indexOf('register') !== -1
            || this.router.url.indexOf('forgot-password') !== -1 || this.router.url.indexOf('verify-otp') !== -1
            || this.router.url.indexOf('reset-password') !== -1;
    }

    changeStyleAccordingLanguage() {
        if (localStorage.getItem('saveLanguage')) {
            const url = JSON.parse(localStorage.getItem('saveLanguage')).language;
            if (url === 'ml' || url === 'ta') {
                this.language = true;
            } else {
                this.language = false;
            }
        } else {
            this.language = false;
        }
    }

    closeModel() {
        $('.our_modal').each(function () {
            $(this).css({
                'bottom': -$(this).innerHeight(),
                'visibility': 'hidden',
                'opacity': '0',
            });
        });
        $('.full_view').removeClass('modal-show');
    }

}
